import React, { useState, useEffect } from 'react';
import { useRouter } from 'next/router';
import LocationIcon from '@/assets/Icons/location.svg';
import EditIcon from '@/assets/Icons/edit.svg';
import {
    PincodeContainer,
    LocationIconWrapper,
    PincodeTitle,
    PincodeValue,
    EditIconWrapper,
} from './styles';
import { PINC_CODE_MESSAGES } from './messages';
import PincodeModal from '@/components/common/pincodeModal';
import { getGarageFromPincode } from '@/components/fakeDoor/api';
import { ROUTEMAP } from '@/components/fakeDoor/constants';
import Router from '@/components/common/router';
import { PAGE_TYPE } from '@/constants/enums';
import { trackEventAPI } from '@/analytics/middleware';
import { TAP_BTN_PINCODE_CONFIRM } from '@/analytics/events';
import { LOCAL_STORAGE_KEYS } from '@/constants/storageKeys';

interface PincodeCardProps {
    pincode: string;
    isloggedInServerSide?: boolean;
    pageType?: PAGE_TYPE;
}

const PincodeCard: React.FC<PincodeCardProps> = ({
    pincode,
    isloggedInServerSide = false,
    pageType,
}) => {
    const router = useRouter();
    const [showPincodeModal, setShowPincodeModal] = useState(false);
    const [isServiceable, setIsServiceable] = useState<boolean | null>(null);
    // useEffect(() => {
    //     if (!pincode && isloggedInServerSide) {
    //         const timer = setTimeout(() => {
    //             setShowPincodeModal(true);
    //         }, 1000);

    //         return () => clearTimeout(timer);
    //     }
    // }, [pincode, isloggedInServerSide]);

    useEffect(() => {
        if (pincode) {
            const checkServiceability = async () => {
                const res = await getGarageFromPincode(pincode as string);
                if (res?.id) {
                    setIsServiceable(true);
                } else {
                    setIsServiceable(false);
                }
            };
            checkServiceability();
        } else {
            setIsServiceable(null);
        }
    }, [pincode]);

    const ctaHandler = async (
        newPincode: string,
        currentGarageId: string = ''
    ) => {
        const res = await getGarageFromPincode(newPincode as string);
        if (newPincode) {
            localStorage.setItem(LOCAL_STORAGE_KEYS.PINCODE, newPincode);
        }
        if (res?.id) {
            localStorage.setItem(LOCAL_STORAGE_KEYS.GARAGE_ID, res?.id);
        } else {
            if (localStorage.getItem(LOCAL_STORAGE_KEYS.GARAGE_ID)) {
                localStorage.removeItem(LOCAL_STORAGE_KEYS.GARAGE_ID);
            }
        }
        trackEventAPI({
            event_name: TAP_BTN_PINCODE_CONFIRM,
            customAttributes: {
                page_type: pageType,
            },
            isFakeDoor: true,
        });
        if (currentGarageId === res?.id) {
            setShowPincodeModal(false);
            return;
        }

        const queryParams = new URLSearchParams();
        queryParams.set('pincode', newPincode);
        if (res?.id) {
            queryParams.set('garageId', res.id.toLowerCase());
        }

        const redURL = res?.id
            ? `/?${queryParams.toString()}`
            : `${ROUTEMAP.GARAGE_COMING_SOON}?pincode=${newPincode}`;

        Router.replace(redURL);
        setShowPincodeModal(false);
    };

    const handleEditClick = () => {
        setShowPincodeModal(true);
    };

    return (
        <>
            <PincodeContainer>
                <LocationIconWrapper>
                    <LocationIcon />
                </LocationIconWrapper>
                <PincodeTitle>
                    {pincode
                        ? PINC_CODE_MESSAGES.TITLE
                        : PINC_CODE_MESSAGES.SECOND_TITLE}
                </PincodeTitle>
                <PincodeValue>{pincode}</PincodeValue>
                <EditIconWrapper onClick={handleEditClick}>
                    <EditIcon />
                </EditIconWrapper>
            </PincodeContainer>
            <PincodeModal
                ctaHandler={ctaHandler}
                showModal={showPincodeModal}
                closeModal={() => setShowPincodeModal(false)}
                type={!pincode ? 'new' : 'edit'}
                subText={
                    isServiceable
                        ? PINC_CODE_MESSAGES.EDIT_SUBTEXT
                        : PINC_CODE_MESSAGES.NOT_SERVICEABLE_SUBTEXT
                }
                prefilledPincode={pincode}
            />
        </>
    );
};

export default PincodeCard;
